/**
 * Real height of the block that sits above the sticky header (confirm country
 * banner + monogram + marketing strip).
 *
 * `HeaderStripWrapper` measures `#strips-container` and writes the result into
 * `--header-strip-wrapper`, so this value follows what is actually rendered:
 * brands without marketing strip messages, the global website (monogram
 * collapsed), the confirm country banner and the viewport breakpoints.
 *
 * Summing `--marketing-strip-max-height` and `--monogram-strip-height` instead
 * gives the design tokens, which stay at their full value even when those
 * elements are not on screen.
 */
export function useHeaderStripsHeight() {
  const stripsHeightCssVar = useCssVar('--header-strip-wrapper', null, {
    observe: true,
  })

  const stripsHeight = computed(() => removePx(stripsHeightCssVar.value))

  return {
    stripsHeight,
  }
}
